export const ERROR_MESSAGES: Record<string, string> = {
  SEARCH_UNAVAILABLE:
    "Legal references are temporarily unavailable. Your draft will continue without them.",
  CHECKPOINT_ERROR: "We lost track of your draft session. Please retry.",
  PERSIST_FAILED: "Your draft could not be saved. Please retry.",
  VALIDATION_ERROR: "Some input could not be processed. Please check and retry.",
  UNKNOWN_ERROR: "Something went wrong. Please retry or report the issue.",
}

export function resolveMessage(code: string, backendMessage?: string): string {
  return backendMessage ?? ERROR_MESSAGES[code] ?? ERROR_MESSAGES["UNKNOWN_ERROR"]
}
